module.exports = __webpack_public_path__ + "img/home_06.94ee687c.png";